<template>
  <div class="module-content">
    <!-- Header -->
    <div class="module-header">
      <div class="left">
        <router-link class="back" to="/users" title="Back to list" select-cy="back">
          <i class="icn icn-chevron-left"></i>
        </router-link>
        <h2>
          <span v-if="itemLoaded">{{ item.firstName }} {{ item.lastName }}</span>
          <span v-if="!itemLoaded">Loading</span>
        </h2>
      </div>

    <div class="right">
      <button
        class="action delete"
        title="Delete item"
        @click="deleteItem()"
        v-if="canDelete"
        select-cy="delete"
      >
        <i class="icn icn-trash sm"></i>
      </button>
    </div>

  </div>

    <!-- Content -->
    <div class="content w-full">
      <!-- Loading -->
      <div v-if="isLoading" class="container w-max">
        <div class="flex flex-col items-center">
          <img class="h-36 mt-20" src="@/assets/img/loading.svg" />
          <h2>Fetching item</h2>
        </div>
      </div>

      <!-- Info -->
      <div v-if="itemLoaded" class="container module-item">
        <!-- User Information -->
        <div class="section">
          <div class="head">
            <div class="title">
              <h3>User Details</h3>
              <p class="sub-title">
                Created: {{ item.createdAt | date('dd-MM-yyyy HH:mm') }} - Last Updated:
                {{ item.updatedAt | date('dd-MM-yyyy HH:mm') }}
              </p>
            </div>
          </div>
          <div class="body halved">
            <!-- General Details -->
            <div class="details">
              <div class="intro">
                <h4>General Information</h4>
                <a class="edit" @click="open(modalNames.EDIT_DETAILS)" v-if="canEdit" select-cy="edit-details">Edit Details</a>
              </div>

              <dl class="fields desc">
                <div class="field">
                  <dt class="label">First Name</dt>
                  <dd class="value">{{ item.firstName }}</dd>
                </div>
                <div class="field">
                  <dt class="label">Last Name</dt>
                  <dd class="value">{{ item.lastName }}</dd>
                </div>
                <div class="field">
                  <dt class="label">Email</dt>
                  <dd class="value">{{ item.email }}</dd>
                </div>
                <div class="field">
                  <dt class="label">Company</dt>
                  <dd class="value">{{ item.company ? item.company.name : '-' }}</dd>
                </div>
              </dl>
            </div>

            <!-- Security Details -->
            <div class="details">
              <div class="intro">
                <h4>Security</h4>
                <a class="edit" @click="open(modalNames.SECURITY_DETAILS)" v-if="canEdit">Edit Details</a>
              </div>

              <dl class="fields desc">
                <div class="field">
                  <dt class="label">SSO ID</dt>
                  <dd class="value">{{ item.ssoId }}</dd>
                </div>
                <div class="field">
                  <dt class="label">Created Date</dt>
                  <dd class="value">{{ item.creationDate | date('dd-MM-yyyy HH:mm') }}</dd>
                </div>
                <div class="field" v-if="isSuperAdmin">
                  <dt class="label">Super Admin</dt>
                  <dd class="value">
                    <span class="badge" :class="item.isSuperAdmin ? 'green' : 'red'">
                      {{ item.isSuperAdmin ? 'Yes' : 'No' }}
                    </span>
                  </dd>
                </div>
                <div class="field">
                  <dt class="label">Account Status</dt>
                  <dd class="value">
                    <span class="badge" :class="item.isEnabled ? 'green' : 'red'">
                      {{ item.isEnabled ? 'Enabled' : 'Disabled' }}
                    </span>
                  </dd>
                </div>
                <div class="field" v-if="canEdit">
                  <dt class="label">Send Reset Password Email</dt>
                  <dd class="value">
                    <button @click="resetPassword()">Reset Password</button>
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </div>

        <!-- Roles -->
        <!-- <div class="section">
          <div class="head list">
            <div class="title">
              <h3>Roles and Permissions</h3>
            </div>
          </div>
          <div class="body halved">
            <div class="details">
              <div class="intro">
                <h4>Roles</h4>
                <a
                  class="edit"
                  @click="open(modalNames.GRANT_ROLE)"
                  v-if="canEdit && item.roles && item.roles.length === 0"
                  select-cy="grant-roles"
                >
                  Grant Roles
                </a>
              </div>
              <Table
                :items="item.roles"
                :attributes="rolesTableAttributes"
                :options="rolesTableOptions"
                @delete="revokeRole"
                @head="open(modalNames.GRANT_ROLE)"
              ></Table>
            </div>
            <div class="details">
              <div class="intro">
                <h4>Permissions</h4>
              </div>
              <Table
                :items="item.permissions"
                :attributes="permissionTableAttributes"
                :options="permissionsTableOptions"
              ></Table>
            </div>
          </div>
        </div> -->
      </div>

      <!-- Item Not Found -->
      <div v-if="itemNotFound" class="container">Item Not found</div>
    </div>

    <!-- Modals -->
    <UserEditDetails v-if="isEditDetailsOpen"></UserEditDetails>
    <UserEditSecurityDetails v-if="isSecurityDetailsOpen"></UserEditSecurityDetails>
    <UserGrantRole v-if="isGrantRoleOpen"></UserGrantRole>
  </div>
</template>

<script>
// import Table from '@/components/Table.vue';
import UserEditDetails from './UserEditDetails.vue';
import UserGrantRole from './UserGrantRole.vue';
import UserEditSecurityDetails from './UserEditSecurityDetails.vue';
import { MODAL_NAME } from './../store';
import firebase from 'firebase/app';
import { CONFIRM_COLOR, GRANT_ACTION, MESSAGES } from '@/helpers/constants';
import { PERMISSION, MODULE } from '@/helpers/security';

export default {
  name: 'UserView',
  components: {
    UserEditDetails,
    UserEditSecurityDetails,
    UserGrantRole,
  },

  data() {
    return {
      isLoading: false,
      roles: [],
      permissionsTableOptions: {
        discreet: true,
        pages: [10],
      },
      rolesTableOptions: {
        headAction: 'Grant Role',
        delete: true,
        deleteLabel: 'Revoke',
        discreet: true,
        pages: [10],
      },
      rolesTableAttributes: [{ name: 'name', label: 'Name' }],
      permissionTableAttributes: [
        { name: 'name', label: 'Name' },
        { name: 'description', label: 'Description' },
      ],
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    item() {
      return this.$store.getters['users/getUser'];
    },
    itemLoaded() {
      return !!this.item && !this.isLoading;
    },
    itemNotFound() {
      return !this.item && !this.isLoading;
    },
    modalNames() {
      return MODAL_NAME;
    },
    isEditDetailsOpen() {
      return this.$store.getters['users/isEditDetailsOpen'];
    },
    isSecurityDetailsOpen() {
      return this.$store.getters['users/isSecurityDetailsOpen'];
    },
    isGrantRoleOpen() {
      return this.$store.getters['users/isGrantRoleOpen'];
    },
    canEdit() {
      return this.$store.getters['auth/hasAccess'](MODULE.USER, PERMISSION.EDIT);
    },
    isSuperAdmin() {
      return this.$store.getters['auth/isSuperAdmin'];
    },
    canDelete() {
      return this.$store.getters['auth/hasAccess'](MODULE.USER, PERMISSION.DELETE);
    }
  },
  watch: {
    canEdit() {
      this.rolesTableOptions.delete = this.canEdit;
    },
    isEditDetailsOpen(isOpen) {
      if (!isOpen) this.fetchUser();
    },
    isSecurityDetailsOpen(isOpen) {
      if (!isOpen) this.fetchUser();
    },
    isGrantRoleOpen(isOpen) {
      if (!isOpen) this.fetchUser();
    },
  },

  created() {
    this.fetchUser();
    this.rolesTableOptions.delete = this.canEdit;
  },

  methods: {
    fetchUser() {
      this.isLoading = true;
      this.$store
        .dispatch('users/get', {
          ids: this.id,
          includeRoles: true,
          includePermissions: true,
          detailedPermissions: true,
        })
        .then(({ data }) => {
          this.$store.commit('users/itemLoaded', data[0]);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    open(modalName) {
      this.$store.commit('users/open', modalName);
    },
    resetPassword() {
      this.$store
        .dispatch('confirm/confirm', {
          color: CONFIRM_COLOR.INFO,
          details: `Would you like to send a reset password email to ${this.item.email}?`,
        })
        .then((res) => {
          if (res) {
            firebase
              .auth()
              .sendPasswordResetEmail(this.item.email)
              .then(() => {
                this.$store.dispatch('notifications/success', {
                  headline: 'Reset Password',
                  details: 'The reset password email has been sent.',
                });
              })
              .catch(() => {
                this.$store.dispatch('notifications/error', {
                  headline: 'Reset Password',
                  details:
                    "We couldn't send the reset password email. Please try again later or contact an administrator.",
                });
              });
          }
        });
    },
    revokeRole(role) {
      this.$store
        .dispatch('confirm/confirm', {
          color: CONFIRM_COLOR.DANGER,
          details: `Would you like to revoke the "${role.name}" role?`,
        })
        .then((res) => {
          if (res) {
            const payload = {
              userId: this.id,
              roleId: role.id,
              action: GRANT_ACTION.REVOKE,
            };
            this.$store
              .dispatch('users/updateRole', [payload])
              .then(() => {
                this.fetchUser();
              })
              .catch((err) => {
                console.error(err);
                this.$store.dispatch('notifications/error', {
                  headline: 'Cannot Revoke Role',
                  details: "We couldn't revoke the role, Please try again later.",
                });
              });
          }
        });
    },
    deleteItem() {
      this.$store
        .dispatch('confirm/confirm', {
          color: CONFIRM_COLOR.DANGER,
          details: `Would you like to delete this item? This action is irreversible.`,
        })
        .then((res) => {
          if (res) {
            this.isLoading = true;
            this.$store
              .dispatch('users/delete', this.item.id)
              .then(() => {
                this.$store.dispatch('notifications/success', { headline: MESSAGES.SUCCESSFUL_DELETE });
                this.$router.push(`/users`);
              })
              .catch((err) => console.error(err));
          }
        });
    },
  },
};
</script>